import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

// TODO 移動させる
var hostname = window.location.hostname
var baseurl = window.location.protocol + '//' + hostname + '/'
if (hostname.indexOf('localhost') !== -1) {
  baseurl = 'http://dev.morecon.jp/'
  // TODO localhostではdev.morecon.jpのセッションがないので、一度通しておく
}
const BASE_URL = baseurl

//  データストア
var CustomerStore = new Vuex.Store({
  state: {
    buttonName: '',
    user: {
      // MypageButton
      login: false,
      // UserStateBar
      firstName: 'テスト',
      lastName: '剛司',
      point: 0,
      // CartButton
      itemCount: 0
    }
  },
  mutations: {
    /**
     * お客様情報を取得、設定する
     * @param state
     * @param parameters
     */
    setCustomer (state, parameters) {
      state.user.login = parameters.is_login
      state.user.firstName = parameters.customer.name02
      state.user.lastName = parameters.customer.name01
      state.user.itemCount = parameters.cart_quantity
      state.user.point = parameters.customer.point
    },
    /**
     * ボタンのテキストを取得する
     * @param state
     */
    getButtonName (state) {
      state.buttonName = state.user.login ? 'マイページ' : '登録・ログイン'
    }
  },
  getters: {},
  actions: {
    /**
     * loadCustomer
     * @param commit
     */
    loadCustomer ({ commit, state }) {
      axios.get(BASE_URL + 'rest/customer')
        .then(response => {
          if (response.status === 200) {
            if (response.data.success) {
              commit('setCustomer', response.data)
              commit('getButtonName')
            } else {
              // TODO Error API
              if (window.confirm('通信に失敗しました。\nページを再読込しますか。')) {
                location.reload()
              }
            }
          }
        }).catch(reason => {
          if (window.confirm('通信に失敗しました。\nページを再読込しますか。')) {
            location.reload()
          }
        })
    }
  }
})

export default CustomerStore



// WEBPACK FOOTER //
// ./src/stores/CustomerStore.js